// extracted by mini-css-extract-plugin
export default {"legalRow":"footerLegal_legalRow__rksqh","copyrightRow":"footerLegal_copyrightRow__KydQs"};